// extracted by mini-css-extract-plugin
export default {"fixed":"FixedWeb_fixed__RM46S","round":"FixedWeb_round__UO5w0","h5":"FixedWeb_h5__bxScK","h6":"FixedWeb_h6__ZO4z-"};